<template>
	<div v-show="visible" class="loading-wrap">
		<div class="loading-box">
            <div class="load"></div>
        </div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			visible: true
		}
	}
}
</script>
<style scoped>
.loading-wrap {
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	background:#fff;
    z-index: 999;
}
.loading-box {
	position: absolute;
	left: 50%;
    transform: translateX(-50%);
	top: 200px;
}
.load{
    width:30px;
    height:30px;
    border:2px solid #fff;
    border-radius:50%;
    border-top:2px solid #4da5ff;
    animation:load .8s linear infinite;
}
@-webkit-keyframes load {
    0%{
        transform: rotate(0deg);
    }
    100%{
        transform:rotate(360deg);
    }
}
@-moz-keyframes load {
    0%{
        transform: rotate(0deg);
    }
    100%{
        transform:rotate(360deg);
    }
}
@-o-keyframes load {
    0%{
        transform: rotate(0deg);
    }
    100%{
        transform:rotate(360deg);
    }
}
</style>


// WEBPACK FOOTER //
// src/directive/loading/loading.vue